import ColoredHeader from '../../../common/components/layout/ColoredHeader';
import {Col, Container, Row} from 'reactstrap';
import Panel from '../../../common/components/Panel';
import MandatoryInput from '../../../common/components/layout/MandatoryInput';
import {birthDateToAge, dateFormatFR} from '../../../utils';
import {CenteredP} from '../../../common/components/StyledComp';
import DisplayTag from '../../../common/components/DisplayTag';
import TicketPreview from './TicketPreview';
import TicketRating from './TicketRating';
import TicketComments from './TicketComments';
import {Modal} from 'react-bootstrap';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import {withLoadedUser} from '../../../login/containers/AuthBase';
import {ROLES} from '../../../common/constants';
import {flowRight as compose} from 'lodash';
import DisplayBoolean from '../../../common/components/DisplayBoolean';

const MargedContainer = styled(Container)`
  margin-bottom: 10px;
`;

const ModalHeader = styled(Modal.Header)`
  && {
    padding: 0;
    border-bottom: 0;
  }
`;

const AttributeDiv = styled.div`
  text-transform: uppercase;
  font-family: 'Segoe UI Bold', sans-serif;
`;

const MargedCol = styled(Col)`
  margin-bottom: 10px;
`;

export const userBarcode = (t, user) => user ? user.barcode : t('unknown');

const TicketDetailsModal = ({t, receipt, showModal, currentUser, changeModalState}) => {
  const translationVars = {
    date: dateFormatFR({date: receipt.createdAt}),
    user: userBarcode(t, receipt.user),
  };

  const {role} = currentUser;

  return (
    <Modal
      show={showModal}
      onHide={() => changeModalState(false)}
      size="xl">
      <ModalHeader closeButton>
        <ColoredHeader className="info-header">{t('receiptFrom', translationVars)}</ColoredHeader>
      </ModalHeader>
      <MargedContainer>
        <Row>
          <Col xl={4} xs={12} >
            <Panel title={t('details')}>
              <MandatoryInput
                disabled
                title={`${t('createdAt')} : `}
                name="createdAt"
                value={dateFormatFR({date: receipt.createdAt})}
              />
              <Col xs={12}>
                <AttributeDiv>{t('tags')}</AttributeDiv>
              </Col>
              <Col xs={12}>
                {receipt.tags.rows.length === 0 && <CenteredP>{t('ticketInfo.noTag')}</CenteredP>}
                {receipt.tags.rows.map(tag => <DisplayTag key={tag.id} tag={tag}/>)}
              </Col>
              {role === ROLES.ADMIN && (
                <>
                  <Col xs={12}>
                    <AttributeDiv>{t('isPro')}</AttributeDiv>
                  </Col>
                  <Col xs={12}>
                    <DisplayBoolean bool={receipt.isPro}/>
                  </Col>
                </>
              )}
            </Panel>
          </Col>
          <MargedCol xl={8} xs={12}>
            <Panel title={t('popinDetails.receiptThumbnail')} pdf={true}>
              <TicketPreview receipt={receipt}/>
            </Panel>
          </MargedCol>
          <Col xs={12}/>
          <Col xs={4}>
            <Panel title={t('user.title')}>
              <MandatoryInput
                disabled
                title={`${t('civility')} : `}
                name="civility"
                value={receipt.user && t(`civilities.${receipt.user.civility}`)}
              />
              {role === ROLES.ADMIN && (
                <>
                  <MandatoryInput
                    disabled
                    title={`${t('user.lastName')} : `}
                    name="lastName"
                    value={receipt.user && receipt.user.lastName}
                  />
                  <MandatoryInput
                    disabled
                    title={`${t('user.firstName')} : `}
                    name="firstName"
                    value={receipt.user && receipt.user.firstName}
                  />
                  <MandatoryInput
                    disabled
                    title={`${t('user.email')} : `}
                    name="email"
                    value={receipt.user && receipt.user.email}
                  />
                </>
              )}
              <MandatoryInput
                disabled
                title={`${t('user.age')} : `}
                name="age"
                value={receipt.user && receipt.user.birthDate ? t('user.yearsold', {age: birthDateToAge(receipt.user.birthDate)}) : ''}
              />
              <MandatoryInput
                disabled
                title={`${t('firstOrder')} : `}
                name="loyaltyCard"
                value={receipt.isFirstOrder ? t('yes') : t('no')}
              />
              <MandatoryInput
                disabled
                title={`${t('loyaltyCard')} : `}
                name="loyaltyCard"
                value={receipt.userHasLoyaltyCard ? t('yes') : t('no')}
              />
            </Panel>
          </Col>
          <Col xs={8}>
            <Panel title={t('comments')}>
              <Container>
                <TicketRating receipt={receipt}/>
                <TicketComments receipt={receipt}/>
              </Container>
            </Panel>
          </Col>
        </Row>
      </MargedContainer>
    </Modal>
  );
};

TicketDetailsModal.propTypes = {
  t: PropTypes.func.isRequired,
  receipt: PropTypes.object.isRequired,
  showModal: PropTypes.bool.isRequired,
  currentUser: PropTypes.shape({
    role: PropTypes.string,
  }),
  changeModalState: PropTypes.func.isRequired,
};

export default compose(
  withLoadedUser,
  withTranslation('ticket'),
)(TicketDetailsModal);
